import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { Icon } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        //backgroundColor: "#EEEFF2",
    },
}));

const StandardList = props => {
    const { dataList, primary, secondary, selectItem, key, icon } = props
    const classes = useStyles();
    return (
        <div style={{
            padding: "20px",
            // border: '2px solid #BEBCC0',
            
            borderRadius: "8px",
            // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
        }}>
            <List className={classes.root}>
                {
                    dataList.map(data => {
                        if (data.img !== undefined) {
                            return <ListItem key={data.id ? data.id : key} button onClick={() => selectItem(data)} >
                                <img src={process.env.PUBLIC_URL + data.img} alt="Logo" style={{ width: isMobile ? '100%' : '80%' }} />
                            </ListItem>
                        }
                        return <ListItem key={data.id ? data.id : key} button onClick={() => selectItem(data)} >
                            <ListItemAvatar>
                                <Avatar >
                                    <Icon> {data.icon ? data.icon : icon}</Icon>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<span style={data.pstyle ? data.pstyle : {}} >{`${data[primary]}`}</span>}
                                secondary={<span style={data.sstyle ? data.sstyle : { color: '#000000' }} >{data[secondary]}</span>} />
                        </ListItem>
                    })
                }
            </List>
        </div>

    );
};

StandardList.propTypes = {
    dataList: PropTypes.array.isRequired,
    primary: PropTypes.string.isRequired,
    secondary: PropTypes.string.isRequired,
    selectItem: PropTypes.func.isRequired,
    icon: PropTypes.node,
};

export default StandardList;